import "./App.css";
import Hangman from "./components/Hangman.js";
import Header from "./components/Header";

const App = () => {
  return (
    <>
      <Header />
      <Hangman />
    </>
  );
};

export default App;
